import api from './api';

export const officerService = {
  async getOfficers(params = {}) {
    try {
      const response = await api.get('/officers', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch officers');
    }
  },

  async getOfficer(id) {
    try {
      const response = await api.get(`/officers/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch officer');
    }
  },

  async createOfficer(data) {
    try {
      const response = await api.post('/officers', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create officer');
    }
  },

  async updateOfficer(id, data) {
    try {
      const response = await api.put(`/officers/${id}`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update officer');
    }
  },

  async deleteOfficer(id) {
    try {
      const response = await api.delete(`/officers/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete officer');
    }
  },

  async searchOfficers(query) {
    try {
      const response = await api.get('/officers', { 
        params: { search: query }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to search officers');
    }
  },

  async getOfficersByType(type) {
    try {
      const response = await api.get('/officers', { 
        params: { type }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch officers by type');
    }
  },

  async getOfficersByStatus(status) {
    try {
      const response = await api.get('/officers', { 
        params: { status }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch officers by status');
    }
  }
};
